import AdminLayout from "./AdminLayout";
import { useEffect, useState } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import CustomizedSnackbars from "../../Feedback";
import { IoIosAddCircle } from "react-icons/io";
import { connect } from 'react-redux';
import { addExistingAction } from "../../../Firebase/actions/addExistingAction";
import moment from "moment";

const AddExistingStudent = ({ addExistingAction, addExistingSuccess, addExistingError, resetSuccess }) => {

    const [title, setTitle] = useState('');
    const [ forenames, setForeNames ] = useState('');
    const [ surname, setSurname ] = useState('');
    const [ dob, setDob ] = useState('');
    const [ gender, setGender ] = useState('');
    const [ maritalStatus, setMaritalStatus ] = useState('');
    const [ placeOfBirth, setPlaceOfBirth ] = useState('');
    const [ nationality, setNationality ] = useState('');
    const [ citizenship, setCitizenship ] = useState('');
    const [ idNumber, setIdNumber ] = useState('');
    const [ email, setEmail ] = useState('');
    const [ phoneNumber, setPhoneNumber ] = useState('');
    const [ address, setAddress ] = useState('');

    const [ programme, setProgramme ] =  useState('');
    const [ programmeCode, setProgrammeCode ] =  useState(''); 

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const [ error, setError ]  =  useState(false); 


    const handleSubmit = (e) => {
        e.preventDefault();
        if(title !== '' || forenames  !== '' || surname  !== '' || dob  !== '' || gender  !== '' || maritalStatus  !== '' || placeOfBirth  !== '' || nationality  !== '' || citizenship  !== '' || idNumber  !== '' || email  !== '' || phoneNumber  !== '' || programme  !== '' || programmeCode){
            setError(false);
            document.getElementById('Btn').classList.add('is-loading');
            //add to db
            let data = {
                title,
                forenames,
                surname,
                dob,
                gender,
                maritalStatus,
                placeOfBirth,
                nationality,
                citizenship,
                idNumber,
                email,
                phoneNumber,
                programme,
                class: programmeCode,
                applicationStatus: 'accepted'
            }
            addExistingAction(data);
        } else {
            setError(true);
        }

    }

    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });
        
        if(addExistingSuccess) {
            //REST FORM
            setForeNames('');
            setSurname('');
            setDob('');     
            setMaritalStatus('');
            setPlaceOfBirth('');
            setNationality('');
            setCitizenship('');
            setIdNumber('');
            setEmail('');
            setPhoneNumber('');
            setAddress('');
            //on success
            setFeedbackText('Student successfully added.');
            setSeverity('success');
            setOpenFeedback(true);
            document.getElementById('Btn').classList.remove('is-loading');

            resetSuccess();
 
        }

        if(addExistingError) {
            //on error
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);
            document.getElementById('Btn').classList.remove('is-loading');

        }

        var defaultDate= new Date('January 1, 2010');

        var datepicker = document.querySelectorAll('.datepicker');
        let selectedDate;
        M.Datepicker.init(datepicker, {
            yearRange: [1980,2010],
            showMonthAfterYear: true,
            defaultDate,
            setDefaultDate: true,
            format: 'dd mmmm yyyy',
            onSelect: (date) => {
                selectedDate = moment(date).format('DD MMMM YYYY');
            },
            onClose: () => {
                setDob(selectedDate);
            }
        });

    }, [addExistingSuccess, addExistingError, resetSuccess]);
    
    return ( 
        <AdminLayout>
           <div className="row pt-5">
                <div className="col s12 m10 l10 offfset-m1 offset-l1">
                    <h5 className="title has-text-weight-bold mt-6 mb-2 grey-text text-darken-3">Add Student</h5>
                    <div className="divider mb-5"></div>

                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col s12">
                                <div className="row">
                                    <div className="input-field col s4 m2">
                                        <select onChange={(e) => setTitle(e.target.value)} value={title} >
                                            <option value="" disabled>Select</option>
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Miss">Miss</option>
                                        </select>
                                        <label>Title</label>
                                    </div>
                                    <div className="input-field col s8 m5 l4">
                                        <input id="lastName" type="text" onChange={(e) => setSurname(e.target.value)} value={surname} required />
                                        <label htmlFor="lastName" className="active">Last Name</label>
                                    </div>
                                    <div className="input-field col s12 m5 l6">
                                        <input id="firstName" type="text" onChange={(e) => setForeNames(e.target.value)} value={forenames} required />
                                        <label htmlFor="firstName" className="active">Forename(s)</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field col s12 m4">
                                        <input id="dateOfBirth" type="text" className="datepicker" defaultValue={dob} />
                                        <label htmlFor="dateOfBirth" className="active">Date Of Birth:</label>
                                    </div>
                                    <div className="input-field col s4">
                                        <select onChange={(e) => setGender(e.target.value)} value={gender} >
                                            <option value="" disabled>Select</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                        </select>
                                        <label>Gender</label>
                                    </div>
                                    <div className="input-field col s4">
                                        <select onChange={(e) => setMaritalStatus(e.target.value)} value={maritalStatus} >
                                            <option value="" disabled>Select</option>
                                            <option value="Single">Single</option>
                                            <option value="Married">Married</option>
                                        </select>
                                        <label>Marital Status</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field col s12 m3">
                                        <input id="pob" type="text" onChange={(e) => setPlaceOfBirth(e.target.value)} value={placeOfBirth} />
                                        <label htmlFor="pob" className="active">Place of Birth</label>
                                    </div>
                                    <div className="input-field col s12 m4">
                                        <input id="nationality" type="text" onChange={(e) => setNationality(e.target.value)} value={nationality} required />
                                        <label htmlFor="nationality" className="active">Nationality</label>
                                    </div>
                                    <div className="input-field col s12 m5">
                                        <input id="citizenship" type="text" onChange={(e) => setCitizenship(e.target.value)} value={citizenship} required />
                                        <label htmlFor="citizenship" className="active">Citizenship</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field col s12 m6">
                                        <input id="idNumber" type="text" onChange={(e) => setIdNumber(e.target.value)} value={idNumber} />
                                        <label htmlFor="idNumber" className="active">National ID No. (e.g 123456A78)</label>
                                    </div>
                                    <div className="input-field col s12 m6">
                                        <input id="email" type="email" className="validate" onChange={(e) => setEmail(e.target.value)} value={email} required />
                                        <label htmlFor="email" className="active">Email</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field col s12 m5">
                                        <input id="phoneNumber" type="text" onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber} required />
                                        <label htmlFor="phoneNumber" className="active">Phone Number</label>
                                    </div>
                                    <div className="input-field col s12 m7">
                                        <textarea id="address" className="materialize-textarea" onChange={(e) => setAddress(e.target.value)} value={address} required ></textarea>
                                        <label htmlFor="address" className="active">Address</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h5 className="is-size-5 has-text-weight-semibold mt-6 mb-4 grey-text text-darken-3">Programme: </h5>
                        <div className="row">
                            <div className="input-field col s12 m6 l4 ">
                                <select onChange={(e) => setProgramme(e.target.value)} value={programme} >
                                    <option value="" disabled>Select</option>
                                    <optgroup label="Applied Art">
                                        <option value="Music">Music</option>
                                        <option value="Cosmetology">Cosmetology</option>
                                        <option value="Fashion Design">Fashion Design</option>
                                        <option value="Art and Design">Art and Design </option>
                                        <option value="Clothing">Clothing</option>
                                    </optgroup>
                                    <optgroup label="Applied Science">
                                        <option value="Science Technology">Science Technology</option>
                                        <option value="Horticulture">Horticulture</option>
                                    </optgroup>
                                    <optgroup label="Hospitality">
                                        <option value="Food and Beverage Service">Food & Beverage Service</option>
                                        <option value="Bakery Studies">Bakery Studies</option>
                                        <option value="Tourism and Hospitality Management">Tourism & Hospitality Management</option>
                                        <option value="Professional Cookery">Professional Cookery</option>        
                                    </optgroup>
                                    <optgroup label="Construction and Wood Technology">
                                        <option value="Brick and Block Laying">Brick and Block Laying</option>
                                        <option value="Painting and Decorating">Painting and Decorating</option>
                                        <option value="Plumbing and Drain Laying">Plumbing and Drain Laying</option>
                                        <option value="Carpentry and Joinery">Carpentry and Joinery</option>
                                        <option value="Wood Machines and Manufacturing">Wood Machines and Manufacturing</option>
                                        <option value="Construction Technology">Construction Technology</option>
                                    </optgroup>
                                    <optgroup label="Civil Engineering">
                                        <option value="Civil Engineering">Civil Engineering</option>
                                        <option value="Quantity Surveying Engineering">Quantity Surveying Engineering</option>
                                        <option value="Water Resources and Irrigation Engineering">Water Resources & Irrigation Engineering</option>
                                    </optgroup>
                                    <optgroup label="Automotive">
                                        <option value="Motor Vehicle Body Repairs + Refinishing">Motor Vehicle Body Repairs + Refinishing</option>
                                        <option value="Motor Vehicle Mechanics">Motor Vehicle Mechanics</option>
                                        <option value="Automobile Electrics and Electronics">Automobile Electrics & Electronics</option>
                                    </optgroup>
                                    <optgroup label="Electrical">
                                        <option value="Electrical Power">Electrical Power</option>
                                        <option value="Computer Systems">Computer Systems</option>
                                        <option value="Communication Systems">Communication Systems</option>
                                    </optgroup>
                                    <optgroup label="Mechanical">
                                        <option value="Diesel Plant Fitting">Diesel Plant Fitting</option>
                                        <option value="Fabrication Engineering">Fabrication Engineering</option>
                                        <option value="Machine Shop Engineering">Machine Shop Engineering</option>
                                        <option value="Refrigeration and Air Conditioning">Refrigeration & Air Conditioning</option>
                                        <option value="Production Engineering">Production Engineering</option>
                                        <option value="Mechanical Engineering">Mechanical Engineering</option>
                                    </optgroup>
                                    <optgroup label="Business Studies">
                                        <option value="Accountancy">Accountancy</option>
                                        <option value="Banking and Finance">Banking and Finance</option>
                                    </optgroup>
                                    <optgroup label="Management Studies">
                                        <option value="Transport and Logistics Management">Transport & Logistics Management</option>
                                        <option value="Marketing Management">Marketing Management</option>
                                        <option value="Human Resources">Human Resources</option>
                                        <option value="Purchasing and Supply">Purchasing and Supply</option>
                                    </optgroup>
                                    <optgroup label="Office Management">
                                        <option value="Secretarial">Secretarial</option>
                                        <option value="Office Management">Office Management</option>
                                    </optgroup>
                                    <optgroup label="IM Systems">
                                        <option value="Information Technology">Information Technology</option>
                                        <option value="Library and Information Science">Library and Information Science</option>
                                        <option value="Records Management and Info Science">Records Management and Info Science</option>
                                    </optgroup>
                                    <optgroup label="Education">
                                        <option value="Further Education Trainers Certificate">Further Education Trainers Certificate</option>
                                        <option value="Further Education Trainers Diploma">Further Education Trainers Diploma</option>
                                    </optgroup>
                                </select>
                                <label>Select Student's Programme</label>
                            </div>
                        </div>

                        <h5 className="is-size-5 has-text-weight-semibold mt-6 mb-4 grey-text text-darken-3">Select Accepted Course Code: </h5>
                        <div className="row">
                            <div className="input-field col s12 m4 ">
                                <select onChange={(e) => setProgrammeCode(e.target.value)} value={programmeCode} >
                                        <option value="" disabled>Select</option>
                                        <option value="CV082021 NC1">CV082021 NC1</option>
                                        <option value="CV082021 NC2">CV082021 NC2</option>
                                        <option value="CV012022 NC3">CV012022 NC3</option>
                                        <option value="CV012022 NC4">CV012022 NC4</option>
                                        <option value="CV012022 NC5">CV012022 NC5</option>
                                        <option value="QS082021 NC1">QS082021 NC1</option>
                                        <option value="QS012022 NC2">QS012022 NC2</option>
                                        <option value="QS012022 NC3">QS012022 NC3</option>
                                        <option value="ARC082021 NC1">ARC082021 NC1</option>
                                        <option value="ARC012022 NC2">ARC012022 NC2</option>
                                        <option value="ARC012022 NC3">ARC012022 NC3</option>
                                        <option value="VAL012022 NC1">VAL012022 NC1</option>
                                        <option value="VAL012022 NC2">VAL012022 NC2</option>
                                        <option value="IRR012022 NC1">IRR012022 NC1</option>
                                        <option value="SG012022 NC1">SG012022 NC1</option>
                                        <option value="SG012022 NC2">SG012022 NC2</option>
                                        <option value="UB012022 NC1">UB012022 NC1</option>
                                        <option value="UB012022 NC2">UB012022 NC2</option>
                                        <option value="IT012022 NC1">IT012022 NC1</option>
                                        <option value="IT012022 NC2">IT012022 NC2</option>
                                        <option value="PS012022 NC1">PS012022 NC1</option>
                                        <option value="PS012022 NC2">PS012022 NC2</option>
                                        <option value="TM012022 NC1">TM012022 NC1</option>
                                        <option value="TM012022 NC2">TM012022 NC2</option>
                                        <option value="RM012022 NC1">RM012022 NC1</option>
                                        <option value="RM012022 NC2">RM012022 NC2</option>
                                        <option value="SS012022 NC1">SS012022 NC1</option>
                                        <option value="SS012022 NC2">SS012022 NC2</option>
                                        <option value="MM012022 NC1">MM012022 NC1</option>
                                        <option value="MM012022 NC2">MM012022 NC2</option>
                                        <option value="HR012022 NC1">HR012022 NC1</option>
                                        <option value="HR012022 NC2">HR012022 NC2</option>
                                        <option value="ACC012022 NC1">ACC012022 NC1</option>
                                        <option value="ACC012022 NC2">ACC012022 NC2</option>
                                </select>
                                <label>Select Code: </label>
                            </div>
                        </div>
                        {
                            error && <p className="red-text text-darken-3">Please provide all the required information.</p>
                        }
                        <div className="control">
                            <button className="button is-success mt-5" id="Btn">
                                <span className="icon">
                                <IoIosAddCircle size="1.25rem" color="white"/>
                                </span>
                                <span className="white-text">Add Student</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </AdminLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        addExistingSuccess: state.addExisting.addExistingSuccess,
        addExistingError: state.addExisting.addExistingError,
    }
    
}

const mapDispatchToProps = (dispatch) => {
    return {
        addExistingAction: (data) => dispatch(addExistingAction(data)),
        resetSuccess: () => dispatch({ type: "ADD_EXISTING", success: false })
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(AddExistingStudent);